/* eslint-disable react/prop-types */

import React from 'react'
import PilotSilver from './PilotSilver'
import PilotBronze from './PilotBronze'
import PilotGold from './PilotGold'
import PilotPlatinum from './PilotPlatinum'
import PilotDiamond from './PilotDiamond'

export default class PilotRank extends React.Component {
  render() {
    if (!this.props.userProfile) return <PilotSilver score={0} />

    let score = Math.trunc(this.props.userProfile.avgFlightScore)
    if (this.props.userProfile.userRank.title.toLowerCase() == 'bronze')
      return <PilotBronze score={score} />
    else if (this.props.userProfile.userRank.title.toLowerCase() == 'silver')
      return <PilotSilver score={score} />
    else if (this.props.userProfile.userRank.title.toLowerCase() == 'gold')
      return <PilotGold score={score} />
    else if (this.props.userProfile.userRank.title.toLowerCase() == 'platinum')
      return <PilotPlatinum score={score} />
    else if (this.props.userProfile.userRank.title.toLowerCase() == 'diamond')
      return <PilotDiamond score={score} />
    else return <PilotSilver score={score} />
  }
}
